var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgForwardToInbox(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 41,
    viewBox: "0 0 45 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38.1992 0.962891H4.80078C3.69401 0.962891 2.71745 1.38607 1.87109 2.23242C1.08984 3.01367 0.699219 3.99023 0.699219 5.16211V30.1621C0.699219 31.334 1.08984 32.3431 1.87109 33.1895C2.71745 33.9707 3.69401 34.3613 4.80078 34.3613H23.5508V30.1621H4.80078V9.36133L21.5 19.7129L38.1992 9.36133V19.7129H42.3008V5.16211C42.3008 3.99023 41.8776 3.01367 41.0312 2.23242C40.25 1.38607 39.306 0.962891 38.1992 0.962891ZM21.5 15.6113L4.80078 5.16211H38.1992L21.5 15.6113ZM36.0508 23.9121L44.4492 32.2129L36.0508 40.6113V34.3613H27.75V30.1621H36.0508V23.9121Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgForwardToInbox);
export default __webpack_public_path__ + "static/media/forward_to_inbox.862f3884e3ce53f5a39e9cbbf842b9e9.svg";
export { ForwardRef as ReactComponent };